export default "__VITE_ASSET__084d5383__"